import "./App.css";
import React, { Component } from "react";
import jwtDecode from "jwt-decode";
import { Route, Switch, Redirect } from "react-router-dom";

import http from "./services/httpService";
import Forum from "./components/forum/forum";
import Jumotron from "./components/common/jumbotron";
import NotFound from "./components/not-found";
import NewPost from "./components/createpost";
import Log from "./components/log";
import Logout from "./components/logout";
import Register from "./components/register";
import NavBar from "./components/navbar/navbar";
import ProtectedRoute from "./components/common/protectedRoute";
import PostPage from "./components/forum/PostPage";
import Profile from "./components/profile";
import Consulting from "./components/business-consulting/consulting";
import ConsultingPost from "./components/business-consulting/consultingPost";
import forgotPassword from "./components/forgotPassword";
import SentSuccessfully from "./components/sent";
import resetPassword from "./components/resetPassword";
import Successfully from "./components/Successfully";
import SetLanguageToken from "./components/setlanguage";
import Aos from "aos";
import PostDetail from "./components/business-consulting/PostDetail";
class App extends Component {
  state = {};
  async componentDidMount() {
    try {
      const jwt = localStorage.getItem("token");
      const user_jwt = jwtDecode(jwt);
      const user = await http.get(`${process.env.REACT_APP_API}/users/${user_jwt._id}`);
      this.setState({ user: user.data });
      Aos.init();
      const isMobile = window.matchMedia("(max-width: 1320px)");
      if (!isMobile.matches) 
      import('aos/dist/aos.css').then(() => {
        // CSS file has been loaded
      });
    } catch (ex) {}
  }
  render() {
    return (
      <div>
        <NavBar user={this.state.user} />
        {/* on the dashboard, have a quesry string parameter to 
       to find the method of sorting of posts.(using query string package) */}
        <Switch>
          <Route path="/users/login/:id" component={Log} />
          <Route path="/users/register" component={Register} />
          <Route path="/users/logout/:url" component={Logout} />   
          <Route path="/users/resetpassword/successfully" component={Successfully} />
          <Route path="/users/resetpassword" component={resetPassword} />
          <Route path="/users/forgotpassword/emailsent" component={SentSuccessfully} />
          <Route path="/users/forgotpassword" component={forgotPassword} />
          <Route path="/setlanguage/:url/:lang" component={SetLanguageToken} /> 
          <Route
            path="/forum"
            render={(props) => <Forum {...props} user={this.state.user} />}
          />
          <Route
            path="/consulting"
            render={(props) => <Consulting {...props} user={this.state.user} />}
          />
          <Route
            path="/consulting-post/:id"
            render={(props) => <ConsultingPost {...props} user={this.state.user} />}
          />
          <Route
            path="/pack-post/:id"
            render={(props) => <PostDetail {...props} user={this.state.user} />}
          />
          <Route path="/not-found" component={NotFound} />
          <ProtectedRoute
            path="/new-post"
            render={(props) => <NewPost {...props} user={this.state.user} />}
          />
          <Route
            path="/post/:id"
            render={(props) => <PostPage {...props} user={this.state.user||""} />}
          />
          <Route exact path="/" component={Jumotron} />
          <Route
            path="/profile"
            render={(props) => <Profile {...props} user={this.state.user} />}
          />
          <Redirect from="/users" to="/users/login " />
          <Redirect to="/not-found" />
        </Switch>
      </div>
    );
  }
}

export default App;